import { Box, Typography, Button, useMediaQuery, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { useState } from "react";

const Hero = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [videoLoaded, setVideoLoaded] = useState(false);

  const handleVideoLoaded = () => {
    setVideoLoaded(true);
  };

  return (
    <>
      {/* New Video Hero Section */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100vh", // fallback for old browsers
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Fallback Image - visible until video loads on desktop or always on mobile */}
        <Box
          component="img"
          src="/images/photo-tour/villa-ananda/pool.webp"
          alt="Luxury villa background"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1,
            opacity: isMobile ? 1 : (videoLoaded ? 0 : 1),
            transition: "opacity 0.5s ease-in-out",
          }}
        />

        {/* Video Background - only on desktop */}
        {!isMobile && (
          <Box
            component="video"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            poster="/videos/home.jpg"
            onCanPlayThrough={handleVideoLoaded}
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: -1,
              opacity: videoLoaded ? 1 : 0,
              transition: "opacity 0.5s ease-in-out",
            }}
          >
            <source src="/videos/home.webm" type="video/webm" />
          </Box>
        )}

        {/* Dark Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 0,
          }}
        />

        {/* Content */}
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            textAlign: "center",
            color: "white",
            px: { xs: 3, md: 6 },
            maxWidth: "1200px",
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "3rem", sm: "4rem", md: "5rem", lg: "6rem" },
              fontWeight: 700,
              lineHeight: 1.1,
              mb: 3,
            }}
            data-aos="fade-up"
          >
            Luxury getaways
            <br />
            you deserve
          </Typography>

          <Typography
            variant="h5"
            color="text.secondary"
            sx={{
              fontSize: { xs: "1rem", sm: "1.3rem", md: "1.3rem" },
              fontWeight: 400,
              mb: 4,
              opacity: 0.9,
              width: { xs: "80%", md: "100%" },
              mx: "auto",
            }}
            data-aos="fade-up"
            data-aos-delay={200}
          >
            Inspire Luxury Goa offers premium villa rentals in North Goa
          </Typography>

          <Link to="/villas" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              size="large"
              color="white"
              sx={{
                px: 4,
                py: 1.5,
                fontSize: "1.1rem",
                fontWeight: 600,
                borderRadius: 50,
                textTransform: "none",
                transition: "all 0.3s ease",
              }}
              data-aos="fade-up"
              data-aos-delay={400}
            >
              Explore villas
            </Button>
          </Link>
        </Box>
      </Box>
    </>
  );
};

export default Hero;
